import React from 'react';

import closeIcon from '../../assets/icons/check.svg';

import { CheckBoxContainer, Container, TextContainer } from './CompositeCheckBox.styles';
import { CompositeCheckBoxProps } from './CompositeCheckBox.types';

/**
 *
 * @deprecated
 * Utilizar o componente CheckBox
 * previsão para ser removido na ver. 1.11.0
 *
 */
const CompositeCheckBox: React.FC<CompositeCheckBoxProps> = ({
  style,
  label,
  description,
  checked,
  updateChecked,
  disabled,
}) => {
  return (
    <Container
      data-testid="composite-checkbox"
      style={style}
      checked={checked}
      disabled={disabled}
      onClick={() => !disabled && updateChecked(!checked)}
    >
      <TextContainer>
        <h4>{label}</h4>
        <p>{description}</p>
      </TextContainer>
      <CheckBoxContainer checked={checked} disabled={disabled}>
        <img src={closeIcon} />
      </CheckBoxContainer>
    </Container>
  );
};

export default CompositeCheckBox;
